<div class="www-acc-hom">
  <app-account-home-top />

  <div #accountTrainingsList>
    <app-trainings-list [perPage]="6" [scrollXOnMobile]="true" [trainingType]="TrainingType.TRAINING" />
  </div>
  <div class="row">
    <div class="col-12 d-flex justify-content-center">
      <a
        class="www-acc-hom__go-all-tra"
        [routerLink]="['/', WwwRouteSlug.ACCOUNT, WwwRouteSlug.PRO_EDUCATION]"
        appGtmClick
        [layer]="{
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'logged user main page',
          eventAction: 'select::pro education trainings',
          eventLabel: 'show more pro education trainings::' + '/' + WwwRouteSlug.ACCOUNT + WwwRouteSlug.PRO_EDUCATION,
          event_name: 'body_button_click',
          module_name: 'pro education trainings',
          cta_name: 'show more pro education trainings',
          link_url: '/' + WwwRouteSlug.ACCOUNT + WwwRouteSlug.PRO_EDUCATION,
        }"
      >
        PRZEJDŹ DO WSZYSTKICH SZKOLEŃ
      </a>
    </div>
  </div>
  <!-- <app-save-the-date /> -->
  <!-- <app-gallery /> -->
  <app-newsletter-section />
</div>
